export default __webpack_public_path__ + "static/media/Hammer of Lambent Fervor.44afc4df.jpg";